import { Button, Grid, Typography } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import React from 'react';
import { SpecialInstructionTooltip } from 'components/Modals/QCPassFailModal/SpecialInstructionTooltip';
import { SPECIAL_INSTRUCTIONS_ATTACHMENT_FIELD_NAME } from 'components/Modals/QCPassFailModal/constants';

export const SpecialInstructionsCheckboxes = ({
  classes,
  isSpecialInstructionsChecked,
  specialInstructionsCheckboxes,
  setSpecialInstructionsCheckboxes,
}) => {
  const handleCheckAll = () => {
    setSpecialInstructionsCheckboxes((prevValue) =>
      prevValue.map((checkbox) => {
        checkbox.checked = true;

        return checkbox;
      }),
    );
  };

  const handleSpecialInstructionCheckboxChanged = (field) => {
    setSpecialInstructionsCheckboxes((prevState) =>
      prevState.map((checkbox) => {
        if (checkbox.field !== field) {
          return checkbox;
        }
        checkbox.checked = !checkbox.checked;

        return checkbox;
      }),
    );
  };

  if (!specialInstructionsCheckboxes) return;

  return (
    <Grid container direction="column">
      {specialInstructionsCheckboxes.map((specialInstruction) => (
        <Grid
          key={specialInstruction.field}
          container
          direction="row"
          alignItems="center"
        >
          <Checkbox
            style={{
              color: specialInstruction.checked ? 'green' : 'red',
            }}
            checked={specialInstruction.checked}
            onChange={() =>
              handleSpecialInstructionCheckboxChanged(specialInstruction.field)
            }
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
          {specialInstruction.field ===
          SPECIAL_INSTRUCTIONS_ATTACHMENT_FIELD_NAME ? (
              <SpecialInstructionTooltip specialInstruction={specialInstruction}>
                <Typography fontWeight="bold">
                  {specialInstruction.label}
                </Typography>
              </SpecialInstructionTooltip>
            ) : (
              <>
                <b>{specialInstruction.label}: </b>
                <Typography className={classes.specialInstructionText}>
                  {specialInstruction.text}
                </Typography>
              </>
            )}
        </Grid>
      ))}
      {specialInstructionsCheckboxes.length > 1 ? (
        <Button
          variant="contained"
          color="secondary"
          onClick={handleCheckAll}
          className={classes.checkAllButton}
          disabled={isSpecialInstructionsChecked}
        >
          <DoneAllIcon />
          Check All
        </Button>
      ) : null}
    </Grid>
  );
};
